import React from 'react';
import {GenerationErrorType} from "../../../../../../../../../../context/ADSProvider";
import styles from './GenerationError.module.scss'

const ErrorDescriptionMap = {
  [GenerationErrorType.General]: {
    textList: [
      "We apologize, but it looks like there was an error during generation. Your credit has not been deducted, please try again."
    ]
  },
  [GenerationErrorType.InappropriatePrompt]: {
    title: 'Inappropriate Content Detected',
    textList: [
      "We strive to provide a positive and respectful experience for all users. Unfortunately, the prompt you entered " +
      "contains language or references that are inappropriate, abusive, offensive. This includes, but is not limited " +
      "to, content related to profanity, sexual content, hate speech, or references to harmful ideologies.",

      "Please revise your prompt and try again.",

      "Thank you for understanding and helping us maintain a safe and welcoming environment."
    ]
  },
  [GenerationErrorType.InappropriateImage]: {
    title: 'Inappropriate Content Detected',
    textList: [
      "We’re sorry, but the image generated based on your prompt did not meet our content guidelines. Sometimes, " +
      "our AI may unintentionally create inappropriate content even from harmless prompts. To ensure a safe and " +
      "appropriate experience for all users, we automatically filter out such images.",

      "Please try again with a different prompt. Don't worry, no credits have been deducted from your account."
    ]
  }
}

const GenerationError = ({errorType}) => {
  const {title, textList} = ErrorDescriptionMap[errorType] || ErrorDescriptionMap[GenerationErrorType.General]
  return (
    <div className={styles.wrapper}>
      {title && <h1>{title}</h1>}
      {textList?.map((text, idx) => <p key={idx}>{text}</p>)}
    </div>
  )
};

export default GenerationError;
